import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['icon', 'role', 'editLink']
  static values = { admin: Boolean }

  confirm() {
    this.showIcon()
    this.showEditLink()
  }

  showEditLink() {
    if (!this.hasEditLinkTarget) return

    if (this.adminValue && this.roleTarget.value !== 'admin') {
      this.editLinkTarget.classList.remove('d-none')
    } else {
      this.editLinkTarget.classList.add('d-none')
    }
  }

  showIcon = () => {
    this.iconTarget.style.display = 'block'
    setTimeout(this.hideIcon, 2000)
  }

  hideIcon = () => {
    this.iconTarget.style.opacity = 0
    setTimeout(this.resetIcon, 1000)
  }

  resetIcon = () => {
    this.iconTarget.style.display = 'none'
    this.iconTarget.style.opacity = 1
  }
}
